var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cover-image-setting-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _setup.closeDialog.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "cover-image-setting-dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _setup.titleId,
            tabindex: "-1",
          },
        },
        [
          _c("header", { staticClass: "cover-image-setting-dialog__header" }, [
            _c("div", {
              staticClass: "cover-image-setting-dialog__header-spacer",
              attrs: { "aria-hidden": "true" },
            }),
            _c(
              "h2",
              {
                staticClass: "cover-image-setting-dialog__title",
                attrs: { id: _setup.titleId },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("novelDetail.coverImageSetting.title")) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "cover-image-setting-dialog__close",
                attrs: {
                  type: "button",
                  disabled: _setup.isSaving,
                  "aria-label": String(_vm.$t("common.close")),
                },
                on: { click: _setup.closeDialog },
              },
              [_c(_setup.IconClose)],
              1
            ),
          ]),
          _setup.step === "select"
            ? [
                _c(
                  "p",
                  { staticClass: "cover-image-setting-dialog__subtitle" },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("novelDetail.coverImageSetting.subtitle"))
                    ),
                  ]
                ),
                _c("div", { staticClass: "cover-image-setting-dialog__grid" }, [
                  _c(
                    "button",
                    {
                      staticClass: "cover-image-setting-card",
                      attrs: { type: "button", disabled: _setup.isSaving },
                      on: { click: _setup.onClickUpload },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "cover-image-setting-card__icon-wrap",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_c(_setup.IconImagePlus)],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "cover-image-setting-card__label" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "novelDetail.coverImageSetting.upload.title"
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        { staticClass: "cover-image-setting-card__desc" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "novelDetail.coverImageSetting.upload.description"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "cover-image-setting-card",
                      attrs: { type: "button", disabled: _setup.isSaving },
                      on: { click: _setup.onClickPreset },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "cover-image-setting-card__icon-wrap",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_c(_setup.IconLayoutGrid)],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "cover-image-setting-card__label" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "novelDetail.coverImageSetting.preset.title"
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        { staticClass: "cover-image-setting-card__desc" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "novelDetail.coverImageSetting.preset.description"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            : [
                _c("div", { staticClass: "cover-image-crop-preview" }, [
                  _c("canvas", {
                    ref: "canvasRef",
                    staticClass: "cover-image-crop-canvas",
                    attrs: { width: "1000", height: "1000" },
                    on: {
                      pointerdown: _setup.onCanvasPointerDown,
                      pointerup: _setup.onCanvasPointerUp,
                      pointercancel: _setup.onCanvasPointerUp,
                      pointermove: _setup.onCanvasPointerMove,
                      wheel: function ($event) {
                        $event.preventDefault()
                        return _setup.onCanvasWheel.apply(null, arguments)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "cover-image-crop-zoom" },
                  [
                    _c(_setup.IconZoomOut, {
                      staticClass: "cover-image-crop-zoom__icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _c("input", {
                      staticClass: "cover-image-crop-zoom__slider",
                      style: {
                        background: `linear-gradient(to right, var(--color-primary) ${
                          _setup.zoomT * 100
                        }%, var(--color-border) ${_setup.zoomT * 100}%)`,
                      },
                      attrs: {
                        type: "range",
                        min: "0",
                        max: "100",
                        step: "1",
                        disabled: _setup.isSaving,
                        "aria-label": String(
                          _vm.$t("novelDetail.coverImageSetting.crop.zoomLabel")
                        ),
                      },
                      domProps: { value: Math.round(_setup.zoomT * 100) },
                      on: { input: _setup.onZoomInput },
                    }),
                    _c(_setup.IconZoomIn, {
                      staticClass: "cover-image-crop-zoom__icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "cover-image-crop-confirm-button",
                    attrs: { type: "button", disabled: _setup.isSaving },
                    on: { click: _setup.onClickConfirmCrop },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "novelDetail.coverImageSetting.crop.confirmButton"
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "cover-image-crop-cancel-button",
                    attrs: { type: "button", disabled: _setup.isSaving },
                    on: { click: _setup.onClickCancelCrop },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                ),
              ],
          _c("input", {
            ref: "fileInputRef",
            staticClass: "cover-image-setting-dialog__file-input",
            attrs: { type: "file", accept: "image/*" },
            on: { change: _setup.onFileChange },
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }